import { ReactNode } from "react";
import cn from "classnames";
import { MotionConfig } from "framer-motion";

import {
  useGetReducedMotion,
  useListenCookieCompletion,
} from "@organisms/page-wrapper/use-cases/page_wrapper_use_cases";

import * as styles from "@organisms/page-wrapper/PageWrapper.module.scss";

interface PageWrapperProps {
  children: ReactNode;
}

const PageWrapper = ({ children }: PageWrapperProps): JSX.Element => {
  const reducedMotion = useGetReducedMotion() as "user" | "always" | "never" | undefined;
  useListenCookieCompletion();

  return (
    <MotionConfig reducedMotion={reducedMotion}>
      <div className={cn(styles.pageWrapper, "page-wrapper")}>{children}</div>
    </MotionConfig>
  );
};

export default PageWrapper;
